[
  {
    "name": "Inventory",
    "routerLink": "/inventory/inventorylist",
    "icon": "inventory",
    "visible":true,
    "enabled":true
  },
  {
    "name": "Requisition",
    "routerLink": "/inventory/requisition",
    "icon": "requisition",
    "visible":true,
    "enabled":true
  },
  {
    "name": "Transfers",
    "routerLink": "/transfer",
    "icon": "transfer",
    "visible": true,
    "enabled": true
  },
  {
    "name": "In-Transit",
    "routerLink": "/in-transit",
    "icon": "transfer",
    "visible": true,
    "enabled": true
  },
  {
    "name": "Physical Inventory",
    "routerLink": "/physicalInventory",
    "icon": "physical-inventory",
    "visible": true,
    "enabled": true
  },
  {
    "name": "Purchase Order",
    "routerLink": "/purchaseOrder/purchase",
    "icon": "PO1",
    "visible": true,
    "enabled": true
  },
  {
    "name": "Document Approvals",
    "routerLink": "/document",
    "icon": "Doc-approval",
    "visible": true,
    "enabled": true
  },
  {
    "name": "Spoilage & Loss",
    "routerLink": "/spoilage",
    "icon": "Spoilage",
    "visible": true,
    "enabled": true
  }, 
  {
    "name": "Offline",
    "routerLink": "/offline",
    "icon": "offline",
    "visible":true,
    "enabled":true
  },  
  {
    "name": "Settings",
    "routerLink": "/setting",
    "icon": "settings",
    "visible":true,
    "enabled":true
  },  
  {
    "name": "About",
    "routerLink": "/about",
    "icon": "About",
    "visible":true,
    "enabled":true
  },  
  {
    "name": "Logout",
    "routerLink": "/login",
    "icon": "logout",
    "visible":true,
    "enabled":true
  },
  {
    "name": "Messages",
    "routerLink": "/message",
    "icon": "message-2-icon",
    "visible": true,
    "enabled": true
  }
]
